/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Andor application API
 * OpenAPI spec version: v1
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  ApprovalRequired,
  CancelJoinRequest200,
  CancelJoinRequestBody,
  CloseRoom200,
  CloseRoomBody,
  CreateRoomBody,
  JoinRoomBody,
  JoinRoomResponse,
  KickUser200,
  KickUserBody,
  ListBansResponse,
  ListRoomsResponse,
  RemoveBan200,
  RemoveBanBody,
  RespondJoinRequest200,
  RespondJoinRequestBody,
  RoomDescriptor,
  UpdateRoomBody
} from '../models';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  ANDOR_BASE_URL
} from '../api.base-url';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};







@Injectable({ providedIn: 'root' })
export class RoomsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(ANDOR_BASE_URL);
 cancelJoinRequest<TData = CancelJoinRequest200>(cancelJoinRequestBody: CancelJoinRequestBody, options?: HttpClientBodyOptions): Observable<TData>;
 cancelJoinRequest<TData = CancelJoinRequest200>(cancelJoinRequestBody: CancelJoinRequestBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 cancelJoinRequest<TData = CancelJoinRequest200>(cancelJoinRequestBody: CancelJoinRequestBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  cancelJoinRequest<TData = CancelJoinRequest200>(
    cancelJoinRequestBody: CancelJoinRequestBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/join/cancel`,
      cancelJoinRequestBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/join/cancel`,
      cancelJoinRequestBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/join/cancel`,
      cancelJoinRequestBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 closeRoom<TData = CloseRoom200>(closeRoomBody: CloseRoomBody, options?: HttpClientBodyOptions): Observable<TData>;
 closeRoom<TData = CloseRoom200>(closeRoomBody: CloseRoomBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 closeRoom<TData = CloseRoom200>(closeRoomBody: CloseRoomBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  closeRoom<TData = CloseRoom200>(
    closeRoomBody: CloseRoomBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/close`,
      closeRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/close`,
      closeRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/close`,
      closeRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 createRoom<TData = JoinRoomResponse>(createRoomBody: CreateRoomBody, options?: HttpClientBodyOptions): Observable<TData>;
 createRoom<TData = JoinRoomResponse>(createRoomBody: CreateRoomBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 createRoom<TData = JoinRoomResponse>(createRoomBody: CreateRoomBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  createRoom<TData = JoinRoomResponse>(
    createRoomBody: CreateRoomBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/create`,
      createRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/create`,
      createRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/create`,
      createRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 getRoomById<TData = RoomDescriptor>(roomId: string, options?: HttpClientBodyOptions): Observable<TData>;
 getRoomById<TData = RoomDescriptor>(roomId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getRoomById<TData = RoomDescriptor>(roomId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getRoomById<TData = RoomDescriptor>(
    roomId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/rooms/${encodeURIComponent(String(roomId))}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/rooms/${encodeURIComponent(String(roomId))}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `${this.baseUrl}/v1/rooms/${encodeURIComponent(String(roomId))}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 joinRoom<TData = JoinRoomResponse | ApprovalRequired>(joinRoomBody: JoinRoomBody, options?: HttpClientBodyOptions): Observable<TData>;
 joinRoom<TData = JoinRoomResponse | ApprovalRequired>(joinRoomBody: JoinRoomBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 joinRoom<TData = JoinRoomResponse | ApprovalRequired>(joinRoomBody: JoinRoomBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  joinRoom<TData = JoinRoomResponse | ApprovalRequired>(
    joinRoomBody: JoinRoomBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/join`,
      joinRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/join`,
      joinRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/join`,
      joinRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 kickUser<TData = KickUser200>(kickUserBody: KickUserBody, options?: HttpClientBodyOptions): Observable<TData>;
 kickUser<TData = KickUser200>(kickUserBody: KickUserBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 kickUser<TData = KickUser200>(kickUserBody: KickUserBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  kickUser<TData = KickUser200>(
    kickUserBody: KickUserBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/kick`,
      kickUserBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/kick`,
      kickUserBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/kick`,
      kickUserBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 listBans<TData = ListBansResponse>( options?: HttpClientBodyOptions): Observable<TData>;
 listBans<TData = ListBansResponse>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 listBans<TData = ListBansResponse>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  listBans<TData = ListBansResponse>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/rooms/bans`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/rooms/bans`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `${this.baseUrl}/v1/rooms/bans`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 listRooms<TData = ListRoomsResponse>( options?: HttpClientBodyOptions): Observable<TData>;
 listRooms<TData = ListRoomsResponse>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 listRooms<TData = ListRoomsResponse>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  listRooms<TData = ListRoomsResponse>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/rooms`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/rooms`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `${this.baseUrl}/v1/rooms`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 removeBan<TData = RemoveBan200>(removeBanBody: RemoveBanBody, options?: HttpClientBodyOptions): Observable<TData>;
 removeBan<TData = RemoveBan200>(removeBanBody: RemoveBanBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 removeBan<TData = RemoveBan200>(removeBanBody: RemoveBanBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  removeBan<TData = RemoveBan200>(
    removeBanBody: RemoveBanBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/bans/remove`,
      removeBanBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/bans/remove`,
      removeBanBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/bans/remove`,
      removeBanBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 respondJoinRequest<TData = RespondJoinRequest200>(respondJoinRequestBody: RespondJoinRequestBody, options?: HttpClientBodyOptions): Observable<TData>;
 respondJoinRequest<TData = RespondJoinRequest200>(respondJoinRequestBody: RespondJoinRequestBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 respondJoinRequest<TData = RespondJoinRequest200>(respondJoinRequestBody: RespondJoinRequestBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  respondJoinRequest<TData = RespondJoinRequest200>(
    respondJoinRequestBody: RespondJoinRequestBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/join/respond`,
      respondJoinRequestBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/join/respond`,
      respondJoinRequestBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/join/respond`,
      respondJoinRequestBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 updateRoom<TData = RoomDescriptor>(updateRoomBody: UpdateRoomBody, options?: HttpClientBodyOptions): Observable<TData>;
 updateRoom<TData = RoomDescriptor>(updateRoomBody: UpdateRoomBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 updateRoom<TData = RoomDescriptor>(updateRoomBody: UpdateRoomBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  updateRoom<TData = RoomDescriptor>(
    updateRoomBody: UpdateRoomBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/update`,
      updateRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/update`,
      updateRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/rooms/update`,
      updateRoomBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};
